"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitIntoLogisticOrderUseCase = void 0;
const splitIntoLogisticOrderUseCase = (lineItemPackagingCriteria) => {
    const packagesByGroupId = lineItemPackagingCriteria.reduce((packages, lineItem) => ({
        ...packages,
        [getPackageGroupingId(lineItem)]: {
            ...createPackage(lineItem),
            lines: addLineToPackage(lineItem, packages[getPackageGroupingId(lineItem)])
        }
    }), {});
    return Object.values(packagesByGroupId);
};
exports.splitIntoLogisticOrderUseCase = splitIntoLogisticOrderUseCase;
function addLineToPackage(lineItem, packageItem) {
    return [
        ...((packageItem === null || packageItem === void 0 ? void 0 : packageItem.lines) || []),
        {
            lineId: lineItem.lineId,
            selectedLogisticOffer: lineItem.selectedLogisticOffer,
            quantity: lineItem.quantity,
            weightInGrams: lineItem.weightInGrams,
            dimensions: lineItem.dimensions
        }
    ];
}
const createPackage = (lineItem) => ({
    sellerId: lineItem.sellerId,
    logisticRoute: lineItem.selectedLogisticOffer.logisticRoute,
    shippingDelay: lineItem.selectedLogisticOffer.realDelay || lineItem.selectedLogisticOffer.delay,
    wishedShippingDateRange: lineItem.wishedShippingDateRange,
    lines: [],
    isPreparationManaged: lineItem.selectedLogisticOffer.isPreparationManaged,
    isTransportManaged: lineItem.selectedLogisticOffer.isTransportManaged
});
const getPackageGroupingId = (lineItem) => {
    var _a, _b, _c, _d;
    return [
        lineItem.sellerId,
        lineItem === null || lineItem === void 0 ? void 0 : lineItem.supplierId,
        lineItem.selectedLogisticOffer.logisticRoute,
        (_a = lineItem.wishedShippingDateRange) === null || _a === void 0 ? void 0 : _a.start,
        (_b = lineItem.wishedShippingDateRange) === null || _b === void 0 ? void 0 : _b.end,
        (_c = lineItem.selectedLogisticOffer.delay) === null || _c === void 0 ? void 0 : _c.unit,
        (_d = lineItem.selectedLogisticOffer.delay) === null || _d === void 0 ? void 0 : _d.value
    ].join(':');
};
